import React, { Component } from 'react';
import styled from 'styled-components'

import Img from 'shared/Img'
import Flex from 'shared/Flex'
import FlexItem from 'shared/FlexItem'

import Link from 'shared/Link'

const HeaderStyled = styled.header`
  .nav-toggle span,
  .nav-toggle span:before {
  cursor: crosshair;
  height: 14px;
  width: 14px;
  background: ${props => props.theme.black};
  display: block;
  content: '';
  z-index: 100 !important;
  }
`

class Header extends Component {
  render() {
    return (
      <HeaderStyled>
        <Flex padding="10px 10px" width="100%" fixed zIndex="100" justifyContent="space-between">
          <FlexItem flex="0 1 100px"><Link to="/" margin="0"><Img style={{filter: 'contrast(.8)'}} src="https://s3.amazonaws.com/aez-project/barragan/logo_800.png" /></Link></FlexItem>
          {
            this.props.small && <FlexItem zIndex={16} onClick={() => this.props.openMenu()} flex="0 0 auto"><a className="nav-toggle"><span></span></a>
            </FlexItem>
          }
        </Flex>

        {
          this.props.small ?
          <Flex padding="10px 10px" width="100%" zIndex="0" hidden justifyContent="space-between">
            <FlexItem flex="0 1 100px"><Img src="https://s3.amazonaws.com/aez-project/barragan/logo_800.png" /></FlexItem>
          </Flex>
          :
          <Flex padding="5px" width="100%" hidden></Flex>

        }

        {
          this.props.small && <Flex fixed top="0" zIndex={8} height="100px" width="100vw" style={{background: 'linear-gradient(to top, rgba(255,255,255,0), rgba(255,255,255,1))'}}></Flex>
        }
      </HeaderStyled>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js